/* eslint-disable react/prop-types */
import React, { createContext, useContext, } from "react";
var Orientation = createContext("vertical");
export function useOrientation() {
    return useContext(Orientation);
}
export function OrientationProvider(_a) {
    var orientation = _a.orientation, children = _a.children;
    return (React.createElement(Orientation.Provider, { value: orientation }, children));
}
//# sourceMappingURL=Orientation.js.map